import { render, staticRenderFns } from "./ShippingMethods.vue?vue&type=template&id=dbc74b7e&"
import script from "./ShippingMethods.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethods.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports